export default {
    aggregateToolbar: {
        from: 'OD',
        to: 'DO',
        countryFilter: 'Filtar države',
        showSplit: 'Prikaži razdvajanje (prognoza vs futures)',
        nothingToSplitTitle: 'Nema prognoze za ovaj raspon — nema se što razdvojiti',
    },
}
